export default "__VITE_ASSET__Cnw66uOc__"